// reducers/test-maintenance/initiative.js

export function initiativeHasErrored(state = false, action) {
  switch (action.type) {
    case 'INITIATIVE_TEST_M_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function initiativeIsLoading(state = false, action) {
  switch (action.type) {
    case 'INITIATIVE_TEST_M_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function initiative(state = {}, action) {
  switch (action.type) {
    case 'INITIATIVE_TEST_M_FETCH_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
}